import { companyUnity } from '../../modules/select';
import { stepTwoValidate } from '../../modules/validator/pages/stepTwo';

// gabarito
const answers = {
  question_1: 'option_2',
  question_2: 'option_2',
  question_3: 'option_2',
  question_4: 'option_2',
  question_5: 'option_3',
  question_6: 'option_1',
  question_7: 'option_1',
  question_8: 'option_3',
  question_9: 'option_3',
  question_10: 'option_1',
};

const $lang = document.documentElement.lang == 'es' ? 'es' : 'pt';

const messages = {
  success: {
    pt: 'Você acertou!',
    es: 'Respuesta correcta',
  },
  error: {
    pt: 'Você errou.',
    es: 'Respuesta equivocada',
  },
};

// Elementos de radio
const $options = document.querySelectorAll('[data-option]');

const disableField = el => {
  el.setAttribute('checked', true);

  const name = el.getAttribute('name');
  const $fields = document.querySelectorAll(`[name="${name}"]:not(:checked)`);

  $fields.forEach(el => el.setAttribute('disabled', true));
};

const showAnswer = el => {
  const name = el.getAttribute('name');
  const value = el.getAttribute('value');

  let $ballon = document.createElement('div');

  if (answers[name] == value) {
    // ACERTOU
    $ballon.classList.add('o-balloon', 'o-balloon--green', 'o-balloon--quiz');
    $ballon.innerHTML = messages.success[$lang];
  } else {
    // ERROU
    $ballon.classList.add('o-balloon', 'o-balloon--red', 'o-balloon--quiz');
    $ballon.innerHTML = messages.error[$lang];
  }
  el.closest('.radio-container').appendChild($ballon);
};

export const stepTwo = () => {
  companyUnity();
  stepTwoValidate();

  // Se existem elementos faz o loop
  $options.length &&
    $options.forEach(el => {
      // Dispara ao selecionar uma resposta
      el.addEventListener('change', e => {
        // Desabilita a questão
        disableField(e.target);

        // Mostra o balão de resposta abaixo
        showAnswer(e.target);
      });
    });
};
